import React from "react";
import { Table } from "rsuite";
import ImageHandler from "../ImageHandler/ImageHandler";
import "../Elements/SharedStyle.css";
const { Cell } = Table;

const ImageCellFormatter = ({
  rowData,
  dataKey,
  onFailedImages,
  openPictureModal,
  dummyImage,
  ...props
}: {
  rowData?: any;
  dataKey: string;
  dummyImage: string;
  onFailedImages: Function;
  openPictureModal: Function;
}) => {
  return (
    <Cell {...props} style={{ padding: 0 }}>
      <div className="img-hndler">
        <ImageHandler
          src={rowData[dataKey]}
          width="40"
          fallback={dummyImage}
          failedImageHandler={(val: any) => onFailedImages(val)}
          onClick={() => openPictureModal(rowData)}
        />
      </div>
    </Cell>
  );
};

export default ImageCellFormatter;
